import type { IFupLogo } from "@bbj-types/organisation";
import { Divider, Stack } from "@mui/material";
import type { Control, UseFormGetValues, UseFormResetField, UseFormSetValue } from "react-hook-form";
import { PartnerFeedbackDecisionForm } from "./decision";
import { PartnerFeedbackInfosForm } from "./infos";
import { SponsorsLogo } from "./logos";
import type { TPartnerFeedbackFormResolver } from "./resolver";

interface IPartnerFeedbackFormProps {
  control: Control<TPartnerFeedbackFormResolver>;
  getValues: UseFormGetValues<TPartnerFeedbackFormResolver>;
  setValue: UseFormSetValue<TPartnerFeedbackFormResolver>;
  resetField: UseFormResetField<TPartnerFeedbackFormResolver>;
  sponsorsLogo: IFupLogo[];
}

export const PartnerFeedbackForm = ({
  control,
  getValues,
  setValue,
  resetField,
  sponsorsLogo,
}: IPartnerFeedbackFormProps) => {
  return (
    <Stack
      sx={{
        gap: 2,
      }}
    >
      <PartnerFeedbackInfosForm control={control} />
      {sponsorsLogo.length > 0 && (
        <SponsorsLogo control={control} getValues={getValues} setValue={setValue} sponsorsLogo={sponsorsLogo} />
      )}
      <Divider />
      <PartnerFeedbackDecisionForm control={control} resetField={resetField} />
    </Stack>
  );
};
